import { animate, sequence, style, transition, trigger } from '@angular/animations'
import { Component, Input, OnInit } from '@angular/core'

@Component({
    selector: 'app-collapsible-section',
    templateUrl: './collapsible-section.component.html',
    styleUrls: ['./collapsible-section.component.scss'],
})
export class CollapsibleSectionComponent implements OnInit {
    @Input() title = ''
    @Input() isActive = false
    @Input() isDisabled = false

    constructor() {}

    ngOnInit(): void {}

    handleCollapse() {
        this.isActive = !this.isActive
    }
}
